/* eslint-disable @typescript-eslint/no-unused-vars */ /**
 * https://github.com/tldraw/tldraw/blob/550b88be8f24979ea525215ba73d22517aee1cfe/packages/tlschema/src/records/TLPageState.ts#L1
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
import { nodeIdValidator } from "../nodes/SWBaseNode";
import { shapeIdValidator } from "../shapes/TLBaseShape";
import { SWINSTANCE_ID } from "./SWInstance";
import { CameraRecordType } from "./TLCamera";
const pageIdValidator = idValidator("page");
/** @internal */ export const instancePageStateValidator = T.model("instance_page_state", T.object({
    typeName: T.literal("instance_page_state"),
    id: idValidator("instance_page_state"),
    pageId: pageIdValidator,
    selectedShapeIds: T.arrayOf(shapeIdValidator),
    hintingShapeIds: T.arrayOf(shapeIdValidator),
    erasingShapeIds: T.arrayOf(shapeIdValidator),
    hoveredShapeId: shapeIdValidator.nullable(),
    editingShapeId: shapeIdValidator.nullable(),
    croppingShapeId: shapeIdValidator.nullable(),
    focusedGroupId: shapeIdValidator.nullable(),
    meta: T.jsonValue,
    // What I've added
    selectedNodeIds: T.arrayOf(nodeIdValidator),
    // selectedNodeRect: T.any,
    expandedNodeIds: T.arrayOf(nodeIdValidator),
    hoveredNodeId: nodeIdValidator.nullable(),
    hintedNodeId: nodeIdValidator.nullable().optional(),
    // hoveredNodeRect: T.any,
    draggingNodeId: nodeIdValidator.nullable().optional()
}));
/** @internal */ export const instancePageStateVersions = {
    AddCroppingId: 1,
    RemoveInstanceIdAndCameraId: 2,
    AddMeta: 3,
    RenameProperties: 4,
    RenamePropertiesAgain: 5,
    AddSelectedNodes: 6
};
/** @public */ export const instancePageStateMigrations = defineMigrations({
    currentVersion: instancePageStateVersions.AddSelectedNodes,
    migrators: {
        [instancePageStateVersions.AddCroppingId]: {
            up (instance) {
                return _object_spread_props(_object_spread({}, instance), {
                    croppingShapeId: null
                });
            },
            down (_param) {
                var { croppingShapeId: _croppingShapeId } = _param, instance = _object_without_properties(_param, [
                    "croppingShapeId"
                ]);
                return instance;
            }
        },
        [instancePageStateVersions.RemoveInstanceIdAndCameraId]: {
            up (_param) {
                var { instanceId: _, cameraId: __ } = _param, instance = _object_without_properties(_param, [
                    "instanceId",
                    "cameraId"
                ]);
                return instance;
            },
            down (instance) {
                // this should never be called since we bump the schema version
                return _object_spread_props(_object_spread({}, instance), {
                    instanceId: SWINSTANCE_ID,
                    cameraId: CameraRecordType.createId("void")
                });
            }
        },
        [instancePageStateVersions.AddMeta]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    meta: {}
                });
            },
            down: (_param)=>{
                var { meta: _ } = _param, record = _object_without_properties(_param, [
                    "meta"
                ]);
                return _object_spread({}, record);
            }
        },
        [instancePageStateVersions.RenameProperties]: {
            // this migration is cursed: it was written wrong and doesn't do anything.
            // rather than replace it, I've added another migration below that fixes it.
            up: (record)=>{
                const { selectedShapeIds, hintingShapeIds, erasingShapeIds, hoveredShapeId, editingShapeId, croppingShapeId, focusedGroupId } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds",
                    "hintingShapeIds",
                    "erasingShapeIds",
                    "hoveredShapeId",
                    "editingShapeId",
                    "croppingShapeId",
                    "focusedGroupId"
                ]);
                return _object_spread({
                    selectedShapeIds: selectedShapeIds,
                    hintingShapeIds: hintingShapeIds,
                    erasingShapeIds: erasingShapeIds,
                    hoveredShapeId: hoveredShapeId,
                    editingShapeId: editingShapeId,
                    croppingShapeId: croppingShapeId,
                    focusedGroupId: focusedGroupId
                }, rest);
            },
            down: (record)=>{
                const { selectedShapeIds, hintingShapeIds, erasingShapeIds, hoveredShapeId, editingShapeId, croppingShapeId, focusedGroupId } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds",
                    "hintingShapeIds",
                    "erasingShapeIds",
                    "hoveredShapeId",
                    "editingShapeId",
                    "croppingShapeId",
                    "focusedGroupId"
                ]);
                return _object_spread({
                    selectedShapeIds: selectedShapeIds,
                    hintingShapeIds: hintingShapeIds,
                    erasingShapeIds: erasingShapeIds,
                    hoveredShapeId: hoveredShapeId,
                    editingShapeId: editingShapeId,
                    croppingShapeId: croppingShapeId,
                    focusedGroupId: focusedGroupId
                }, rest);
            }
        },
        [instancePageStateVersions.RenamePropertiesAgain]: {
            up: (record)=>{
                const { selectedIds, hintingIds, erasingIds, hoveredId, editingId, croppingId, focusLayerId } = record, rest = _object_without_properties(record, [
                    "selectedIds",
                    "hintingIds",
                    "erasingIds",
                    "hoveredId",
                    "editingId",
                    "croppingId",
                    "focusLayerId"
                ]);
                return _object_spread_props(_object_spread({}, rest), {
                    selectedShapeIds: selectedIds,
                    hintingShapeIds: hintingIds,
                    erasingShapeIds: erasingIds,
                    hoveredShapeId: hoveredId,
                    editingShapeId: editingId,
                    croppingShapeId: croppingId,
                    focusedGroupId: focusLayerId
                });
            },
            down: (record)=>{
                const { selectedShapeIds, hintingShapeIds, erasingShapeIds, hoveredShapeId, editingShapeId, croppingShapeId, focusedGroupId } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds",
                    "hintingShapeIds",
                    "erasingShapeIds",
                    "hoveredShapeId",
                    "editingShapeId",
                    "croppingShapeId",
                    "focusedGroupId"
                ]);
                return _object_spread_props(_object_spread({}, rest), {
                    selectedIds: selectedShapeIds,
                    hintingIds: hintingShapeIds,
                    erasingIds: erasingShapeIds,
                    hoveredId: hoveredShapeId,
                    editingId: editingShapeId,
                    croppingId: croppingShapeId,
                    focusLayerId: focusedGroupId
                });
            }
        },
        [instancePageStateVersions.AddSelectedNodes]: {
            up: (record)=>{
                const { selectedShapeIds } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds"
                ]);
                return _object_spread_props(_object_spread({}, rest), {
                    selectedNodeIds: selectedShapeIds
                });
            },
            down: (record)=>{
                const { selectedNodeIds } = record, rest = _object_without_properties(record, [
                    "selectedNodeIds"
                ]);
                return _object_spread_props(_object_spread({}, rest), {
                    selectedShapeIds: selectedNodeIds
                });
            }
        }
    }
});
/** @public */ export const SWInstancePageStateRecordType = createRecordType("instance_page_state", {
    migrations: instancePageStateMigrations,
    validator: instancePageStateValidator,
    scope: "session"
}).withDefaultProperties(()=>({
        editingShapeId: null,
        croppingShapeId: null,
        selectedShapeIds: [],
        hoveredShapeId: null,
        erasingShapeIds: [],
        hintingShapeIds: [],
        focusedGroupId: null,
        meta: {},
        // What I've added
        selectedNodeIds: [],
        // selectedNodeRect: null,
        expandedNodeIds: [],
        hoveredNodeId: null,
        hintedNodeId: null,
        // hoveredNodeRect: null,
        draggingNodeId: null
    }));
